<template>
  <div  style="margin-top: 6em">
    <home-ie></home-ie>
  </div>

</template>

<script>
    import HomeIe from "./HomeIe";
    export default {
        name: "Ie",
      components: {HomeIe}
    }
</script>

<style scoped>

</style>
